// Normalización para BUSCAR (nunca para guardar ni para mostrar).
//
// Los alias de este sistema vienen sucios a propósito: MAYÚSCULAS, tildes
// irregulares y espacios dobles («… STAND  28-42»). El navegador colapsa esos
// espacios al pintarlos, así que quien teclea lo que ve en pantalla no encontraba
// la fila. Se normalizan los dos lados —la consulta y el dato— y el valor guardado
// queda intacto, que es lo que después se copia y se pega en un filtro.
export function normalizeText (value) {
  return (value || '').toString().toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ').trim()
}

// true si `haystack` contiene `needle` una vez normalizados los dos.
export function matches (haystack, needle) {
  return normalizeText(haystack).includes(needle)
}
